var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 202,
    viewBox: "0 0 237 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.508 99.373C122.552 100.078 123.587 100.802 124.686 101.535C169.765 131.984 214.157 153.145 240.493 156.763C241.171 156.846 241.794 156.369 241.894 155.673C241.995 154.968 241.528 154.317 240.804 154.217C214.88 150.681 170.901 129.648 126.088 99.4096C79.7636 68.09 42.3432 33.6376 26.0559 7.24637C25.6895 6.65094 24.9109 6.46774 24.288 6.83415C23.7109 7.20057 23.5093 7.98837 23.8758 8.59296C39.9523 34.6636 76.2827 68.429 121.508 99.373Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.261 101.352C126.976 105.959 133.69 110.329 140.304 114.497L92.8896 146.146L104.184 89.9834C109.388 93.785 114.756 97.5866 120.215 101.352H120.261Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4561 112.674L63.009 56.5942C73.2595 65.9104 84.765 75.4373 97.3606 84.9092L46.4561 112.674Z",
    fill: "#ADADAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78809 72.3589L26.5228 16.8008C34.016 27.3811 44.2208 38.8133 56.6607 50.667L2.78809 72.3589Z",
    fill: "#ADADAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.862 176.77L147.643 119.05C161.072 127.166 174.135 134.329 186.419 140.284L141.862 176.77Z",
    fill: "#ADADAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.991 201.366L195.103 144.342C211.289 151.652 225.763 156.598 237.314 158.632L195.991 201.366Z",
    fill: "#ADADAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.673 92.74C119.763 93.4454 120.808 94.1691 121.852 94.9019C166.976 125.324 211.322 146.512 237.658 150.121C238.391 150.204 239.014 149.727 239.115 149.003C239.215 148.326 238.702 147.675 238.025 147.574C212.055 144.011 168.121 123.006 123.308 92.7675C76.929 61.448 39.5086 27.0047 23.2671 0.613441C22.9007 -0.000309257 22.0671 -0.183518 21.4991 0.19206C20.8762 0.558478 20.7205 1.33712 21.0869 1.95087C37.1085 28.0307 73.4938 61.8052 118.673 92.74Z",
    fill: "#58595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.418 94.7187C124.133 99.3264 130.848 103.696 137.507 107.864L90.0928 139.513L101.333 83.3506C106.536 87.1522 111.904 90.9538 117.418 94.7004C117.418 94.7187 117.418 94.7187 117.418 94.7187Z",
    fill: "#DB0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6123 106.014L60.2202 49.9614C70.4249 59.2776 81.9762 68.777 94.5169 78.2764L43.6123 106.014Z",
    fill: "#F7941E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 65.7261L23.7347 10.168C31.228 20.73 41.4327 32.1805 53.8176 44.025L0 65.7261Z",
    fill: "#8DC63F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.019 170.137L144.845 112.417C158.274 120.533 171.337 127.697 183.566 133.651L139.019 170.137Z",
    fill: "#27AAE1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.203 194.733L192.269 137.709C208.455 145.02 222.929 149.966 234.48 152L193.203 194.733Z",
    fill: "#EE2A7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector11);
export default __webpack_public_path__ + "static/media/vector-11.60b59708f682df9600c608b54e3b55b6.svg";
export { ForwardRef as ReactComponent };